import React from "react";
import { Box, Flex, Grid, SimpleGrid, Text, VisuallyHidden } from "@chakra-ui/react";
import { Logo } from "components/brand/logo";
import { ErrorIcon, SuccessIcon } from "ui/icons";
import { type FeatureDetails, type FeatureComparisonRow } from "./data";

export function ComparisonsTable({ rows }: { rows: FeatureComparisonRow[] }) {
  const ariaDescribedbyId = "traditional-cdp-vs-hightouch-desc";
  return (
    <Flex
      role="table"
      flexDir="column"
      gap="small"
      aria-label="Traditional CDP vs Hightouch"
      aria-describedby={ariaDescribedbyId}
    >
      <VisuallyHidden id={ariaDescribedbyId}>
        Comparisons of features of Traditional CDPs versus Hightouch.
      </VisuallyHidden>

      <SimpleGrid role="rowgroup" columns={2} gap="smaller" justifyItems="center">
        <Text role="columnheader" textStyle="headline2">
          Traditional CDP
        </Text>

        <Box role="columnheader">
          <VisuallyHidden>Hightouch</VisuallyHidden>
          <Logo width="190px" />
        </Box>
      </SimpleGrid>

      <Flex role="rowgroup" flexDir="column" gap="16px">
        {rows.map((c) => (
          <Flex key={c.category} role="row" gap="smaller">
            <VisuallyHidden role="rowheader">{c.category}</VisuallyHidden>
            <FeatureCell {...c.traditionalCdp} />
            <FeatureCell isHightouch {...c.hightouch} />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}

function FeatureCell({ isHightouch, title, description }: FeatureDetails & { isHightouch?: boolean }) {
  return (
    <Box
      role="cell"
      flex={1}
      bg={`new.${isHightouch ? "green" : "gray"}.50`}
      borderRadius="smaller"
      py="30px"
      pl="small"
      pr="biggest"
    >
      <Grid templateColumns="auto auto" columnGap="smaller" rowGap="smallest">
        {isHightouch ? (
          <SuccessIcon color="new.green.500" mt="tiniest" />
        ) : (
          <ErrorIcon mt="tiniest" color="new.yellow.700" />
        )}
        <Text textStyle="headline3" fontSize="brand.md">
          {title}
        </Text>
        <Text textStyle="caption1" gridRow={2} gridColumn={2}>
          {description}
        </Text>
      </Grid>
    </Box>
  );
}
